const MarketingConsentContent = () => {
  return (
    <div className="p-4 text-sm leading-relaxed space-y-6">
      {/* 마케팅 정보 수신동의 헤더 */}
      <div className="text-center">
        {/* <h1 className="text-xl font-bold mb-4">마케팅 정보 수신 동의</h1> */}
        <p className="text-gray-600 mb-6">
          멍투데이는 고객이 수집 및 이용에 동의한 개인정보를 활용하여 전자적 전송매체(앱 푸시, 이메일, 문자)를 통하여 맞춤형 마케팅 알림을 전송할 수 있습니다.
        </p>
      </div>

      {/* 주요 안내사항 */}
      <div className="space-y-4">
        <div className="flex items-start">
          <span className="mr-2 mt-1">•</span>
          <p className="text-sm">
            본 동의는 거부할 수 있습니다. 다만 거부 시 혜택 및 마케팅 알림 수신 및 동의 회원 대상 이벤트 등의 참여가 어려울 수 있습니다.
          </p>
        </div>
        <div className="flex items-start">
          <span className="mr-2 mt-1">•</span>
          <p className="text-sm">
            마케팅 알림은 멍투데이 앱 {'>'} 계정 정보 {'>'} 알림에서 언제든지 등록 또는 철회할 수 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MarketingConsentContent; 